/**
 * Named rather than numeric so a caller cannot invent a size. `nav` is the
 * header's account control, sized to the xs button beside it; `md` is the
 * default, in lists and sheets; `lg` is the account screen's own header.
 */
const PJ_AVATAR_SIZE = {
  NAV: 'nav',
  MD: 'md',
  LG: 'lg'
} as const

type PjAvatarSize = (typeof PJ_AVATAR_SIZE)[keyof typeof PJ_AVATAR_SIZE]

export { PJ_AVATAR_SIZE }
export type { PjAvatarSize }
